<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Inversiones</template>
                    <template slot="en">Investments</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content light-content-secondary">
        <div class="container">
            <list-content class="list-content-download">
                <list-content-item>
                    <p class="title-content title-content-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Listado de Empresas</template>
                            <template slot="en">List of Companies</template>
                        </text-lang>
                    </p>
                    <div class="file-download">
                        <div class="text text-secondary text-file" style="width:70%">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="text text-secondary text-file">Farmacias Auximed</div>
                            </div>
                        </div>
                        <div class="icon-file">
                            <div class="title-content title-content-small" style="margin-bottom:0px">
                                <a href="https://www.auximed.com/" target="_blank">info</a>
                            </div>
                        </div>
                    </div>
                </list-content-item>
            </list-content>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import IconDownload from '@/components/Icons/Download.vue'
import FileDownload from '@/components/FileDownload'
import TextLang from '@/components/TextLang.vue'

export default {
    name: 'Securities',
    props: ['lang'],
    components: {
        Parallax,
        ListContent,
        ListContentItem,
        IconDownload,
        FileDownload,
        TextLang
    }
}
</script>
